module.exports = __webpack_public_path__ + "img/about-slider-bottom-right.c225c60d.jpg";